var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-text',[_c('JobBpeList',{ref:"bpe",attrs:{"selectedCar":_vm.job.car,"job":_vm.job,"branchCode":_vm.job.branchCode},on:{"edited":_vm.edited,"onSelectBpe":_vm.onSelectBpe}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }